export default __webpack_public_path__ + "static/media/noPendingCharities.5e9c08b6.gif";